import * as angular from 'angular';
import { downgradeComponent } from '@angular/upgrade/static';

import { AdminGoogleSheetsToggleComponent } from '@mode/workspace-settings/feature-google';

export const DowngradedWorkspaceSettingsFeatureGoogleAccountModule = angular
  .module('downgraded-workspace-settings-feature-google-account', [])
  .directive('modeAdminGoogleSheetsToggle', downgradeComponent({ component: AdminGoogleSheetsToggleComponent })).name;
